// @ts-nocheck
import { httpClient } from '../../../core/network';
import omitEmpty from 'omit-empty';

class ProductService {
  static fetchProducts(
    { onlyBuyable = true, channels = false, clientSegment = '' } = {}
  ) {
    const apiUrl = '/products';
    return httpClient.get(apiUrl, {
      params: omitEmpty({
        onlyBuyable: onlyBuyable,
        channels: channels,
        clientSegment: clientSegment,
      }),
    });
  }

  static fetchProduct(productId) {
    const apiUrl = `/products/${productId}`;
    return httpClient.get(apiUrl);
  }

  static fetchProductChange(
    {
      productIds = [],
      states = [ 'PENDING' ]
    } = {},
    { sortBy = 'effective_date', sortOrder = 'asc' } = {},
    page = 1,
    limit = 100
  ) {
    const apiUrl = `/products/change`;
    return httpClient.get(apiUrl, {
      params: omitEmpty({
        clientIds: [ 1, 3 ].join(','),
        productIds: productIds.join(','),
        states: states.join(','),
        sortby: sortBy,
        sortorder: sortOrder,
        page,
        limit,
      }),
    });
  }

  static createProductChange(productChangeData) {
    const apiUrl = '/products/change';
    return httpClient.post(apiUrl, productChangeData);
  }

  static deleteProductChange(productChangeId) {
    const apiUrl = `/products/change/${productChangeId}`;
    return httpClient.delete(apiUrl);
  }
}

export default ProductService;
